import * as React from 'react'
import { useCallback, useMemo } from 'react'
import Button from '@mui/material/Button'

import {
  prevScreenActionCreator as prevScreen,
  useSchedulingWizard,
} from './wizardContext'

type CancelButtonProps = {
  _?: never
}

export function BackButton(_props: CancelButtonProps) {
  const [state, dispatch] = useSchedulingWizard()

  const onClickBack = useCallback(() => dispatch(prevScreen()), [dispatch])

  const isStackHasMany = useMemo(() => {
    return state?.stack?.length > 1
  }, [state.stack.length])

  return isStackHasMany ? (
    <Button variant="outlined" onClick={onClickBack}>
      Back
    </Button>
  ) : null
}
